module.exports = __webpack_public_path__ + "static/img/promo (2).84db764.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/restaurant/promo (2).jpg
// module id = rHXv
// module chunks = 1